import H2 from "../Headings/H2";
import './TextLogo.scss';

export default function TextLogo() {
    return (
        <div className={"text-logo"}>
            <span style={{fontWeight: 800, fontSize: "4rem"}} className={"name mb-0"}>
                kenfy
            </span>
        </div>
    )
}